// frontend/src/components/admin/analytics/StudentSelector.tsx

import { useState, useMemo } from 'react';
import { StudentListItem } from '../../../types/studentAnalytics.types';
import { Search, Users } from 'lucide-react';

interface StudentSelectorProps {
  students: StudentListItem[];
  selectedId: string | null;
  onSelect: (id: string) => void;
}

export function StudentSelector({ students, selectedId, onSelect }: StudentSelectorProps) {
  const [search, setSearch] = useState('');

  const filtered = useMemo(
    () => students.filter((s) => s.full_name.toLowerCase().includes(search.toLowerCase())),
    [students, search]
  );

  function getInitials(name: string): string {
    const parts = name.trim().split(' ');
    if (parts.length >= 2) {
      return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
    }
    return name.slice(0, 2).toUpperCase();
  }

  return (
    <div className="student-selector-card">
      <div className="student-selector-header">
        <h3>
          <Users size={18} color="#6366f1" /> Öğrenciler
        </h3>
        <span className="student-count-badge">{students.length} Öğrenci</span>
      </div>

      <div className="analytics-search-wrapper">
        <Search className="analytics-search-icon" size={16} />
        <input
          type="text"
          className="analytics-search-input"
          placeholder="İsim veya soyisim ile ara..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>

      <div className="student-card-list">
        {filtered.map((s) => (
          <button
            key={s.id}
            type="button"
            className={`student-list-item-card ${selectedId === s.id ? 'active' : ''}`}
            onClick={() => onSelect(s.id)}
          >
            <div className="student-item-left">
              <div className="student-avatar-circle">
                {getInitials(s.full_name)}
              </div>
              <div>
                <div className="student-info-name">{s.full_name}</div>
                <div className="student-info-sub">
                  <span className="student-xp-pill">⭐ {s.xp.toLocaleString('tr-TR')} XP</span>
                </div>
              </div>
            </div>
          </button>
        ))}

        {filtered.length === 0 && (
          <div style={{ textAlign: 'center', color: '#64748b', padding: '24px 12px', fontSize: 13 }}>
            Aramaya uygun öğrenci bulunamadı.
          </div>
        )}
      </div>
    </div>
  );
}
